import { render } from "./ControleCobrancasView.vue?vue&type=template&id=f7924374&scoped=true"
import script from "./ControleCobrancasView.vue?vue&type=script&lang=js"
export * from "./ControleCobrancasView.vue?vue&type=script&lang=js"

import "./ControleCobrancasView.vue?vue&type=style&index=0&id=f7924374&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7924374"]])

export default __exports__